import {IPotentiallyMovingObject} from './pmo';
import {ISign} from './sign';
import {IMiscellaneous} from './misc';
import {IOldObject} from "./oldObject";

type TAnyRwoObject = IPotentiallyMovingObject | ISign | IMiscellaneous;
type TAnyObject = TAnyRwoObject | IOldObject;
type TPmoAndMiscProfileNames = "frontProfile" | "sideProfile" | "rearProfile" | "topDownProfile";

const DB_PROFILE_KEY_TO_DISPLAY_NAME: Record<TPmoAndMiscProfileNames, string> = {
  frontProfile: "Front Profile",
  sideProfile: "Side Profile",
  rearProfile: "Rear Profile",
  topDownProfile: "Top Down Profile",
}

interface IFullObjectData {
  fullObjectData: TAnyRwoObject;
  variantData: any;
  selectedVariant: string;
  variantId: string;
}

interface IProcessedObjectData {
  [category: string]: {
    [name: string]: {
      [version: string]: {
        object: TAnyRwoObject;
        variants: {
          [variant: string]: string; // variant name to variantId mapping
        };
      };
    };
  };
}

interface IFetchObjectsResponse {
  rwoData: TAnyRwoObject[]
}

export {DB_PROFILE_KEY_TO_DISPLAY_NAME};

export type {TAnyRwoObject, TAnyObject, TPmoAndMiscProfileNames, IFullObjectData, IProcessedObjectData, IFetchObjectsResponse};
